import type { ReactNode } from "react";

type ModalFrameProps = {
  children: ReactNode;
  overlayClassName?: string;
  panelClassName?: string;
};

export function ModalFrame({
  children,
  overlayClassName = "fixed inset-0 z-[9999] flex items-center justify-center bg-black/40 backdrop-blur-md p-3 sm:p-4",
  panelClassName = "relative w-full max-w-md rounded-xl bg-white shadow-xl max-h-[92dvh] overflow-y-auto",
}: ModalFrameProps) {
  return (
    <div className={overlayClassName}>
      <div className={panelClassName}>{children}</div>
    </div>
  );
}
